
import { connect } from "react-redux";
import { Statements } from "./statements";
import { userLoadStatements, setStatementCurrentYear } from "../../dashboard/user/actions";

const mapDispatchtoProps = dispatch => {
  return {
    userLoadStatements: (acct_index, username) => dispatch(userLoadStatements(acct_index, username)),
    setStatementCurrentYear: (username, index, statement_type, year) => dispatch(
      setStatementCurrentYear(username, index, statement_type, year)),
  };
}

const mapStateToProps = state => {
  return {
    client: state.client,
    user: state.user,
    userDashboard: state.userDashboard,
    app: state.app,
  }
};

export default connect(mapStateToProps, mapDispatchtoProps)(Statements);
